import React, { useState, useEffect, useRef } from "react"
import Layout from "../../components/layouts/layout"
import validation from "./validation"
import PropTypes from "prop-types"
import { useTrackFormStepArrival } from "../../utils/analytics"
import ContinueButton from "components/elements/styledButton/ContinueButton"
import ProgressBar from "utils/stepper"
import MorningApptBanner from "utils/morningApptBanner"
const Insurance = ({ nextStep, pationuser, prevStep, setUser, user }) => {
  useTrackFormStepArrival("insurance_info")
  const inputRef = useRef()
  const [nextBtn, setNextbtn] = useState(false)
  const [errField, setErrField] = useState({
    address1Err: "",
    address2Err: "",
    cityErr: "",
    countryErr: "",
    emailAddress: "",
    lastNameErr: "",
    nameErr: "",
    phoneNumber: "",
    stateErr: "",
    zipCodeErr: "",
  })
  const validForm = async () => {
    return validation.validateWelcomeVisitOnSubmit(
      setErrField,
      user,
      inputRef,
      setUser
    )
  }
  const handleChange = e => {
    validation.validateWelcomeVisitOnChange(e, setErrField, setUser, user)
  }

  const handleSubmit = async () => {
    const formIsValid = await validForm()
    if (formIsValid) {
      console.log(user)
      nextStep()
    }
  }

  const mailAddress = () => {
    if (user.check) {
      setUser({
        ...user,
        address1: "",
        address2: "",
        city: "",
        check: !user.check,
        country: "",
        state: "",
        user,
        zipCode: "",
      })
    } else {
      setUser({
        ...user,
        address1: pationuser.address1,
        address2: pationuser.address2,
        city: pationuser.city,
        country: pationuser.country,
        state: pationuser.state,
        zipCode: pationuser.zipCode,
        check: !user.check,
      })
    }
  }
  useEffect(() => {
    nextCheck(user)
  }, [user])

  const nextCheck = user => {
    if (
      !user.name ||
      !user.lastName ||
      !user.city ||
      !user.country ||
      !user.state ||
      !user.zipCode ||
      !user.address1 ||
      !user.emailAddress ||
      !user.phoneNumber
    ) {
      setNextbtn(false)
    } else {
      if (user.zipCode.length >= 5 && user.phoneNumber.length >= 12) {
        setNextbtn(true)
      } else {
        setNextbtn(false)
      }
    }
  }

  const myStyle = {
    backgroundImage: "url(../images/caret-down.svg)",
  }
  return (
    <>
      <Layout>
        <section className="progress-bar-section">
          <div className="progress-bar-wrapper">
            <ProgressBar activeStep={2} />
          </div>
        </section>
        <MorningApptBanner />
        <section className="patient-information-section">
          <div className="container">
            <div className="patient-heading insurance-heading">
              <h4>Let us check your insurance.</h4>
              <p>
                Please provide your insurance information. Our team will verify
                your coverages, check your eligibility, and work directly with
                your insurance company to attain authorizations so you
                don&apos;t have to!
              </p>
            </div>
            <form className="patient-formSection" onSubmit={handleSubmit}>
              <div className="patient-wrapper">
                <div className="patient-form-wrapper">
                  <div className="pat-form-heading">
                    <h4>Primary Insurance Holder</h4>
                  </div>
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <label className="label" htmlFor="input_first_name">
                        First Name<span>Required*</span>
                      </label>
                      <input
                        className="form-control"
                        id="input_first_name"
                        name="name"
                        onChange={handleChange}
                        placeholder="E.g - John"
                        type="text"
                        value={user.name}
                      />
                      {!user.name && (
                        <span className="input-error">{errField.nameErr}</span>
                      )}
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="label" htmlFor="input_last_name">
                        Last Name<span>Required*</span>
                      </label>
                      <input
                        className="form-control"
                        id="input_last_name"
                        name="lastName"
                        onChange={handleChange}
                        placeholder="E.g - Doe"
                        type="text"
                        value={user.lastName}
                      />
                      {!user.lastName && (
                        <span className="input-error">
                          {errField.lastNameErr}
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="label" htmlFor="input_email_address">
                        Email Address<span>Required*</span>
                      </label>
                      <input
                        className="form-control"
                        id="input_email_address"
                        name="emailAddress"
                        onChange={handleChange}
                        placeholder="john.doe@gmail.com"
                        ref={inputRef}
                        type="text"
                        value={user.emailAddress}
                      />
                      {
                        <span className="input-error">
                          {errField.emailAddressErr}
                        </span>
                      }
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="label">
                        {" "}
                        Phone Number<span>Required*</span>
                      </label>
                      <input
                        className="form-control"
                        name="phoneNumber"
                        onChange={handleChange}
                        placeholder="E.g: 123-456-7890"
                        type="text"
                        value={user.phoneNumber}
                      />
                      {errField.phoneNumberErr && (
                        <span
                          className="input-error"
                          style={{ color: "red", fontSize: "13px" }}
                        >
                          {errField.phoneNumberErr}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 patient-subheading">
                      <h5>
                        Insurance Holder Address
                        <span className="float-end"></span>
                      </h5>
                    </div>
                    <div className="col-md-12">
                      <div className="form-check checkbox-text">
                        <input
                          checked={user.check}
                          className="form-check-input"
                          id="flexCheckDefault"
                          name="checkbox"
                          onChange={mailAddress}
                          type="checkbox"
                          value={user.checkbox}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexCheckDefault"
                        >
                          Mailing Address the same as patient?
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <label className="label" htmlFor="input_address1">
                        Address 1<span>Required*</span>
                      </label>
                      <input
                        className="form-control"
                        id="input_address1"
                        name="address1"
                        onChange={handleChange}
                        placeholder="1234 Street Name"
                        type="text"
                        value={user.address1}
                      />
                      {!user.address1 && (
                        <span className="input-error">
                          {" "}
                          {errField.address1Err}
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="label" htmlFor="input_address2">
                        Address 2<span>Optional*</span>
                      </label>
                      <input
                        className="form-control"
                        id="input_address2"
                        name="address2"
                        onChange={handleChange}
                        placeholder="Apartment, Suite, P.O Box #"
                        type="text"
                        value={user.address2}
                      />
                      {!user.address2 && (
                        <span className="input-error">
                          {" "}
                          {errField.address2Err}
                        </span>
                      )}
                    </div>

                    <div className="col-md-6 form-group">
                      <label className="label" htmlFor="input_city">
                        City<span>Required*</span>
                      </label>
                      <input
                        className="form-control"
                        id="input_city"
                        name="city"
                        onChange={handleChange}
                        placeholder="City"
                        type="text"
                        value={user.city}
                      />
                      {!user.city && (
                        <span style={{ color: "red" }}>
                          {" "}
                          {errField.cityErr}
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="label" htmlFor="selector_state">
                        State<span>Required*</span>
                      </label>
                      <select
                        className="form-select form-control"
                        id="selector_state"
                        name="state"
                        onChange={handleChange}
                        style={myStyle}
                        value={user.state}
                      >
                        <option disabled value="">
                          Select State
                        </option>
                        <option value="AL">Alabama</option>
                        <option value="AK">Alaska</option>
                        <option value="AS">American Samoa</option>
                        <option value="AZ">Arizona</option>
                        <option value="AR">Arkansas</option>
                        {/* <option value="Baker Island">Baker Island</option> */}
                        <option value="CA">California</option>
                        <option value="CO">Colorado</option>
                        <option value="CT">Connecticut</option>
                        <option value="DE">Delaware</option>
                        <option value="DC">District of Columbia</option>
                        <option value="FL">Florida</option>
                        <option value="GA">Georgia</option>
                        <option value="Guam">Guam</option>
                        <option value="HI">Hawaii</option>
                        {/* <option value="HoI">Howland Island</option> */}
                        <option value="ID">Idaho</option>
                        <option value="IL">Illinois</option>
                        <option value="IN">Indiana</option>
                        <option value="IA">Iowa</option>
                        {/* <option value="JI">Jarvis Island</option>
                        <option value="JA">Johnston Atoll</option> */}
                        <option value="KS">Kansas</option>
                        <option value="KY">Kentucky</option>
                        {/* <option value="KR">Kingman Reef</option> */}
                        <option value="LA">Louisiana</option>
                        <option value="ME">Maine</option>
                        <option value="MD">Maryland</option>
                        <option value="MA">Massachusetts</option>
                        <option value="MI">Michigan</option>
                        <option value="MiA">Midway Atoll</option>
                        <option value="MN">Minnesota</option>
                        <option value="MS">Mississippi</option>
                        <option value="MO">Missouri</option>
                        <option value="MT">Montana</option>
                        {/* <option value="NaI">Navassa Island</option>
                        <option value="NE">Nebraska(NE)</option> */}
                        <option value="NV">Nevada</option>
                        <option value="NH">New Hampshire</option>
                        <option value="NJ">New Jersey</option>
                        <option value="NM">New Mexico</option>
                        <option value="NY">New York</option>
                        <option value="NC">North Carolina</option>
                        <option value="ND">North Dakota</option>
                        <option value="NMI">Northern Mariana Islands</option>
                        <option value="Ohio">Ohio</option>
                        <option value="OK">Oklahoma</option>
                        <option value="OR">Oregon</option>
                        {/* <option value="PA">Palmyra Atoll</option> */}
                        <option value="PA">Pennsylvania</option>
                        <option value="PR">Puerto Rico</option>
                        <option value="RI">Rhode Island</option>
                        <option value="SC">South Carolina</option>
                        <option value="SD">South Dakota</option>
                        <option value="TN">Tennessee</option>
                        <option value="TX">Texas</option>
                        <option value="USVI">US Virgin Islands</option>
                        <option value="UT">Utah</option>
                        <option value="VT">Vermont</option>
                        <option value="VA">Virginia</option>
                        {/* <option value="WI">Wake Island</option> */}
                        <option value="WA">Washington(WA)</option>
                        <option value="WV">West Virginia</option>
                        <option value="WIS">Wisconsin</option>
                        <option value="WY">Wyoming</option>
                      </select>
                      {!user.state && (
                        <span className="input-error">
                          {" "}
                          {errField.stateErr}
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="label" htmlFor="selector_country">
                        Country<span>Required*</span>
                      </label>
                      <select
                        className="form-select form-control"
                        id="selector_country"
                        name="country"
                        onChange={handleChange}
                        style={myStyle}
                        value={user.country}
                      >
                        <option disabled>Select A Country</option>
                        <option value="USA">United States of America</option>
                      </select>
                      {!user.country && (
                        <span className="input-error">
                          {errField.countryErr}
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 form-group">
                      <label className="label" htmlFor="input_zipcode">
                        Zip Code<span>Required*</span>
                      </label>
                      <input
                        className="form-control"
                        id="input_zipcode"
                        name="zipCode"
                        onChange={handleChange}
                        placeholder="E.g. 90001"
                        type="text"
                        value={user.zipCode}
                      />
                      {!user.zipCode && (
                        <span className="input-error">
                          {" "}
                          {errField.zipCodeErr}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="btn-wrapper mt-4">
                  <button
                    className="btn btnclose"
                    onClick={prevStep}
                    type="button"
                  >
                    Go Back
                  </button>
                  <ContinueButton disabled={!nextBtn} onClick={handleSubmit}>
                    Next Step
                  </ContinueButton>
                </div>
                <div className="btn-wrapper mt-4 text-end"></div>
              </div>
            </form>
          </div>
        </section>
      </Layout>
    </>
  )
}
Insurance.propTypes = {
  nextStep: PropTypes.func.isRequired,
  pationuser: PropTypes.object.isRequired,
  prevStep: PropTypes.func.isRequired,
  setUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}
export default Insurance
